import axios from 'axios';

const createInstance = (baseURL) => {
  return axios.create({
    baseURL: baseURL,
    timeout: 50000,
    headers: { 'Content-Type': 'application/json' }
  });
};

const instance1 = createInstance('https://api.cnho.io');
const instance3 = createInstance('https://trade.cnho.io');

export { instance1, instance3 };
